module.exports = __webpack_public_path__ + "static/img/img-about_cg2.bf8e5d03.png";